import { AnalyticsEventName } from "../enums/analyticsEventName";
import { IAnalyticsService, IMessagingService } from "../services";
import { Component } from "./component";
import { PageSizeInteractionEvent, PaginationInteractionEvent } from "../models/analytics";

class SearchPager extends Component {
    private analyticsTrackingService: IAnalyticsService;

    constructor(componentEl: HTMLElement, messagingService: IMessagingService, analyticsTrackingService: IAnalyticsService ) {
        super(componentEl, messagingService);

        this.analyticsTrackingService = analyticsTrackingService;

        var paginationPageNumbers = [...componentEl.querySelectorAll<HTMLElement>(".js-search-pagintation-pagenumber")]
        var paginationItemsPerPage = [...componentEl.querySelectorAll<HTMLElement>(".js-search-pagintation-items-per-page")]

        
        paginationPageNumbers.forEach(element => element.addEventListener("click", (e) =>{
            const pageNumber = element.dataset["pagenumber"]
            
            this.analyticsTrackingService.RecordEvent(AnalyticsEventName.Pagination, new PaginationInteractionEvent(pageNumber))
        }))

        paginationItemsPerPage.forEach(element => element.addEventListener("click", (e) =>{
            const pageSize = element.dataset["pagesize"];
            
            this.analyticsTrackingService.RecordEvent(AnalyticsEventName.PageSize, new PageSizeInteractionEvent(pageSize))
        }))
    }
}

export { SearchPager };